var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoldStar = function SvgGoldStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 11",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6 9 3.527 1.854-.674-3.927 2.853-2.781-3.943-.573L6 0 4.237 3.573l-3.943.573 2.853 2.781-.674 3.927z",
    fill: "#FFDC92",
    fillRule: "evenodd"
  })));
};
export default SvgGoldStar;